import React from 'react'
import PopulationChart from './PopulationChart'

export default function Population() {
  return (
    <>
      <PopulationChart />
    </>
  )
}
